var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVaccinationCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5255 15.5151C13.3248 15.5151 13.9727 14.8436 13.9727 14.0151C13.9727 13.1867 13.3248 12.5151 12.5255 12.5151C11.7262 12.5151 11.0782 13.1867 11.0782 14.0151C11.0782 14.8436 11.7262 15.5151 12.5255 15.5151Z",
    fill: "url(#paint0_linear_4402_12210)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87695 6.51514H6.73636V6.01514C6.73636 5.4847 6.53305 4.976 6.17116 4.60092C5.80927 4.22585 5.31845 4.01514 4.80666 4.01514C4.29487 4.01514 3.80404 4.22585 3.44215 4.60092C3.08026 4.976 2.87695 5.4847 2.87695 6.01514V6.51514Z",
    fill: "url(#paint1_linear_4402_12210)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8929 28.5151H12.5256V29.0151C12.5254 29.7541 12.2607 30.4668 11.7827 31.0151H27.9632C28.475 31.0151 28.9658 30.8044 29.3277 30.4293C29.6896 30.0543 29.8929 29.5456 29.8929 29.0151V28.5151Z",
    fill: "url(#paint2_linear_4402_12210)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0101 21.98L21.325 22.685L22.0101 23.395L22.6903 22.685L22.3478 22.335L22.0101 21.98Z",
    fill: "url(#paint3_linear_4402_12210)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9728 5.01514V6.01514H15.4201C15.548 6.01514 15.6707 6.06782 15.7612 6.16158C15.8517 6.25535 15.9025 6.38253 15.9025 6.51514V8.01514H16.8673V6.51514C16.8673 6.38253 16.9182 6.25535 17.0086 6.16158C17.0991 6.06782 17.2218 6.01514 17.3498 6.01514H18.797V5.01514H17.3498C17.2218 5.01514 17.0991 4.96246 17.0086 4.86869C16.9182 4.77492 16.8673 4.64775 16.8673 4.51514V3.01514H15.9025V4.51514C15.9025 4.64775 15.8517 4.77492 15.7612 4.86869C15.6707 4.96246 15.548 5.01514 15.4201 5.01514H13.9728Z",
    fill: "url(#paint4_linear_4402_12210)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7131 23.3301C23.63 23.3283 23.5475 23.3166 23.4671 23.2951L22.6903 24.1001C22.601 24.1936 22.4947 24.2678 22.3775 24.3184C22.2603 24.369 22.1347 24.3951 22.0077 24.3951C21.8808 24.3951 21.7551 24.369 21.6379 24.3184C21.5208 24.2678 21.4144 24.1936 21.3251 24.1001L19.6221 25.8701L18.9371 25.1601L20.6449 23.3951C20.5547 23.3025 20.4831 23.1923 20.4343 23.0709C20.3854 22.9495 20.3603 22.8192 20.3603 22.6876C20.3603 22.5561 20.3854 22.4258 20.4343 22.3044C20.4831 22.1829 20.5547 22.0727 20.6449 21.9801L21.4216 21.1751C21.377 21.0061 21.3763 20.8278 21.4195 20.6584C21.4627 20.4889 21.5483 20.3343 21.6676 20.2101L25.0784 16.6751L24.3981 15.9701L25.0687 15.2701V6.01514C25.0687 5.4847 24.8654 4.976 24.5035 4.60092C24.1416 4.22585 23.6508 4.01514 23.139 4.01514H18.7972C19.0531 4.01514 19.2985 4.12049 19.4794 4.30803C19.6604 4.49557 19.762 4.74992 19.762 5.01514V6.01514C19.762 6.28035 19.6604 6.53471 19.4794 6.72224C19.2985 6.90978 19.0531 7.01514 18.7972 7.01514H17.8323V8.01514C17.8323 8.28035 17.7307 8.53471 17.5497 8.72224C17.3688 8.90978 17.1234 9.01514 16.8675 9.01514H15.9026C15.6467 9.01514 15.4013 8.90978 15.2204 8.72224C15.0394 8.53471 14.9378 8.28035 14.9378 8.01514V7.01514H13.9729C13.717 7.01514 13.4716 6.90978 13.2907 6.72224C13.1097 6.53471 13.0081 6.28035 13.0081 6.01514V5.01514C13.0081 4.74992 13.1097 4.49557 13.2907 4.30803C13.4716 4.12049 13.717 4.01514 13.9729 4.01514H6.95844C7.43645 4.56348 7.70118 5.27613 7.70137 6.01514V29.0151C7.70137 29.5456 7.90468 30.0543 8.26657 30.4293C8.62846 30.8044 9.11929 31.0151 9.63107 31.0151C10.1429 31.0151 10.6337 30.8044 10.9956 30.4293C11.3575 30.0543 11.5608 29.5456 11.5608 29.0151V28.5151C11.5608 28.2499 11.6624 27.9956 11.8434 27.808C12.0243 27.6205 12.2697 27.5151 12.5256 27.5151H25.0687V22.3451L24.3981 23.0401C24.2159 23.2271 23.9695 23.3314 23.7131 23.3301ZM17.3499 10.5151H23.139V11.5151H17.3499V10.5151ZM17.3499 12.5151H23.139V13.5151H17.3499V12.5151ZM17.3499 14.5151H23.139V15.5151H17.3499V14.5151ZM17.3499 16.5151H23.139V17.5151H17.3499V16.5151ZM9.1144 16.1361L9.79655 15.4291L10.1376 15.7831L10.5154 15.3916C10.3442 15.1258 10.2241 14.8282 10.1617 14.5151H9.63107V15.0151H8.66622V13.0151H9.63107V13.5151H10.1617C10.224 13.2022 10.3439 12.9045 10.5149 12.6386L10.1371 12.2471L9.79606 12.6011L9.11391 11.8941L10.4782 10.4796L11.1604 11.1866L10.8193 11.5401L11.197 11.9316C11.4537 11.7541 11.741 11.6296 12.0432 11.5651V11.0151H11.5608V10.0151H13.4905V11.0151H13.0081V11.5651C13.3101 11.6295 13.5972 11.7538 13.8537 11.9311L14.2315 11.5396L13.8904 11.1861L14.5726 10.4791L15.9369 11.8936L15.2547 12.6006L14.9136 12.2466L14.5359 12.6381C14.7071 12.9042 14.8272 13.2019 14.8895 13.5151H15.4202V13.0151H16.385V15.0151H15.4202V14.5151H14.8895C14.8273 14.8281 14.7074 15.1257 14.5364 15.3916L14.9141 15.7831L15.2552 15.4291L15.9373 16.1361L14.573 17.5506L13.8909 16.8436L14.232 16.4901L13.8542 16.0986C13.5976 16.2762 13.3103 16.4006 13.0081 16.4651V17.0151H13.4905V18.0151H11.5608V17.0151H12.0432V16.4651C11.7412 16.4007 11.454 16.2765 11.1975 16.0991L10.8198 16.4906L11.1608 16.8441L10.4787 17.5511L9.1144 16.1361ZM18.3147 26.0151H9.63107V25.0151H18.3147V26.0151ZM18.3147 24.0151H9.63107V23.0151H18.3147V24.0151ZM18.3147 22.0151H9.63107V21.0151H18.3147V22.0151ZM18.3147 20.0151H9.63107V19.0151H18.3147V20.0151Z",
    fill: "url(#paint5_linear_4402_12210)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.398 18.7949L23.7129 19.5049L24.398 20.2099L23.7129 20.9199L23.0327 20.2099L22.3477 20.9199L23.7129 22.3349L25.0685 20.9299V19.4899L24.398 18.7949Z",
    fill: "url(#paint6_linear_4402_12210)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1968 17.7351L30.877 17.0301L27.4663 13.4951L26.786 14.2001L27.8281 15.2851L26.4628 16.7001L26.101 16.3251V16.3201L25.0783 15.2601L25.0686 15.2701V16.6651L25.0783 16.6751L25.0686 16.6851V20.9301V22.3451L27.8088 19.5051L28.489 20.2101L29.174 19.5051L28.1465 18.4451L27.7847 18.0701L29.1499 16.6551L30.1968 17.7351ZM26.4435 19.5051L25.0783 18.0901L25.7585 17.3851L27.1237 18.8001L26.4435 19.5051Z",
    fill: "url(#paint7_linear_4402_12210)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4402_12210",
    x1: 11.2599,
    y1: 12.4499,
    x2: 14.2278,
    y2: 14.5349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB64F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2026,
    stopColor: "#D464F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4457,
    stopColor: "#AC64F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#8F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#7D64FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7764FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4402_12210",
    x1: 3.11924,
    y1: 3.96076,
    x2: 5.73031,
    y2: 6.8958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB64F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2026,
    stopColor: "#D464F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4457,
    stopColor: "#AC64F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#8F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#7D64FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7764FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4402_12210",
    x1: 12.9196,
    y1: 28.4608,
    x2: 13.8818,
    y2: 33.5362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB64F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2026,
    stopColor: "#D464F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4457,
    stopColor: "#AC64F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#8F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#7D64FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7764FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4402_12210",
    x1: 21.4107,
    y1: 21.9492,
    x2: 22.8106,
    y2: 22.9327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB64F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2026,
    stopColor: "#D464F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4457,
    stopColor: "#AC64F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#8F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#7D64FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7764FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4402_12210",
    x1: 14.2756,
    y1: 2.90638,
    x2: 19.2221,
    y2: 6.38147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB64F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2026,
    stopColor: "#D464F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4457,
    stopColor: "#AC64F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#8F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#7D64FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7764FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4402_12210",
    x1: 8.09598,
    y1: 3.42786,
    x2: 30.4959,
    y2: 14.3738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB64F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2026,
    stopColor: "#D464F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4457,
    stopColor: "#AC64F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#8F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#7D64FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7764FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4402_12210",
    x1: 22.5185,
    y1: 18.7179,
    x2: 25.6914,
    y2: 20.4937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB64F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2026,
    stopColor: "#D464F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4457,
    stopColor: "#AC64F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#8F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#7D64FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7764FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4402_12210",
    x1: 25.4332,
    y1: 13.3026,
    x2: 32.6745,
    y2: 16.7631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB64F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2026,
    stopColor: "#D464F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4457,
    stopColor: "#AC64F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#8F64FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#7D64FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7764FB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaccinationCard);
export default __webpack_public_path__ + "static/media/Vaccination Card.acedff0bd240d9e372c3e15f7dc833aa.svg";
export { ForwardRef as ReactComponent };